var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('IconBtn',{attrs:{"title":"Add","icon":"mdi-plus"},on:{"click":function($event){return _vm.handleAdd()}}}),_c('List',{staticClass:"my-3",attrs:{"items":_vm.salesOrganizations}}),_c('Form')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }